import React from 'react'
import PropTypes from 'prop-types'
import CodeBlock from '../../../../../../atoms/CodeBlock'

function SourceQueryDisplay ({ sourceQuery }) {
  return (
    <div style={{ marginBottom: '16px' }}>
      <h4>Source Query</h4>
      <CodeBlock language='sql' code={sourceQuery} />
    </div>
  )
}

SourceQueryDisplay.propTypes = {
  sourceQuery: PropTypes.string.isRequired
}

export default SourceQueryDisplay
